var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhiteNoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "140 128.85 96 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "924c69c16f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 140 128.851562 L 236 128.851562 L 236 206.851562 L 140 206.851562 Z M 140 128.851562 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#924c69c16f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 187.300781 128.851562 C 160.882812 128.851562 140.125 145.203125 140.125 165.332031 C 140.125 175.398438 147.671875 185.464844 155.847656 192.382812 C 155.21875 199.300781 144.527344 202.445312 140.125 206.851562 C 149.558594 206.851562 160.882812 203.703125 167.171875 198.671875 C 172.203125 199.929688 182.269531 201.816406 187.929688 201.816406 C 214.347656 201.816406 235.109375 185.464844 235.109375 165.332031 C 235.109375 145.203125 213.71875 128.851562 187.300781 128.851562 Z M 187.300781 128.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 187.394531 186.785156 C 174.960938 186.785156 164.878906 176.707031 164.878906 164.273438 C 164.878906 151.835938 174.960938 141.757812 187.394531 141.757812 C 199.828125 141.757812 209.910156 151.835938 209.910156 164.273438 C 209.910156 176.707031 199.828125 186.785156 187.394531 186.785156 Z M 187.394531 137.300781 C 172.703125 137.300781 160.796875 149.207031 160.796875 163.898438 C 160.796875 178.589844 172.703125 190.496094 187.394531 190.496094 C 202.085938 190.496094 213.992188 178.589844 213.992188 163.898438 C 213.992188 149.207031 202.085938 137.300781 187.394531 137.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 199.714844 163.882812 L 187.824219 144.15625 L 187.824219 158.46875 L 199.714844 163.882812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 187.824219 159.40625 L 187.824219 171.800781 L 199.65625 164.792969 L 187.824219 159.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 200.105469 166.296875 L 187.824219 173.554688 L 187.824219 183.640625 L 200.105469 166.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 186.96875 144.15625 L 175.074219 163.878906 L 186.96875 158.46875 L 186.96875 144.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 186.96875 159.40625 L 175.132812 164.792969 L 186.96875 171.800781 L 186.96875 159.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 174.683594 166.296875 L 186.96875 183.640625 L 186.96875 173.554688 L 174.683594 166.296875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteNoText);
export default __webpack_public_path__ + "static/media/logo-white-no-text.b524ae803e581c7629140a2a6931d750.svg";
export { ForwardRef as ReactComponent };